import { withOktaAuth } from '@okta/okta-react'
import applogo from 'assets/images/ChoicePropElLogo.png'
import RouteConst from 'constants/RouteConst'
import React, { Component } from 'react'
import { Nav, Navbar } from 'react-bootstrap'
import { FaHome, FaPowerOff, FaQuestion, FaUser } from 'react-icons/fa'
import { withRouter } from 'react-router'
import { NavLink } from 'react-router-dom'
import menuIcon from '../../../assets/images/icons/list.svg'
import './Header.scss'
class Header extends Component {

    constructor(props) {
        super(props)
        this.logout = this.logout.bind(this)
    }

    async logout() {
        this.props.history.push(RouteConst.ROUTE_LOGOUT_PAGE)
    }

    render() {
        return (
            <Navbar expand="md" sticky="top" collapseOnSelect id='header-row' className='header'>
                <Navbar.Brand>
                    <NavLink to={RouteConst.ROUTE_HOME_PAGE} className='nav-link'>
                        <img id='app-logo' className='app-logo' src={applogo} alt='logo' />
                    </NavLink>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <img src={menuIcon} alt='Menu' />
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav>
                        <NavLink to={RouteConst.ROUTE_HOME_PAGE} className='nav-link'><FaHome id='header-home-icon' /><br className='d-none d-md-block' /><span className='link-text'>Home</span></NavLink>
                        <NavLink to={RouteConst.ROUTE_ACCOUNT_PAGE} className='nav-link'><FaUser id='header-account-icon' /><br className='d-none d-md-block' /><span className='link-text'>Account</span></NavLink>
                        <Nav.Link onClick={this.logout}><FaPowerOff id='header-logout-icon' /><br className='d-none d-md-block' /><span className='link-text'>Close</span></Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        )
    }
}

export default withOktaAuth(withRouter(Header))


export function registerIcons() {
    library.add(
        FaHome, FaUser, FaQuestion, FaPowerOff
    );
}